module.exports = {"TXTCLI_Back":{"id":"TXTCLI_Back","defaultMessage":"Tillbaka","flags":["TRACK"],"track":"Back"}}